var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8044 24.1205L22.0879 19.8331V11.0997C22.0879 10.2215 21.3781 9.51172 20.4999 9.51172C19.6218 9.51172 18.912 10.2215 18.912 11.0997V20.6272C18.912 21.1274 19.147 21.599 19.5472 21.8976L25.8988 26.6613C26.1729 26.8678 26.5068 26.9793 26.85 26.9789C27.3343 26.9789 27.8107 26.7614 28.1219 26.3421C28.6492 25.6418 28.5063 24.6462 27.8044 24.1205Z",
    fill: "#6A6A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C9.19561 0 0 9.19561 0 20.5C0 31.8044 9.19561 41 20.5 41C31.8044 41 41 31.8044 41 20.5C41 9.19561 31.8044 0 20.5 0ZM20.5 37.8242C10.9487 37.8242 3.17582 30.0513 3.17582 20.5C3.17582 10.9487 10.9487 3.17582 20.5 3.17582C30.0529 3.17582 37.8242 10.9487 37.8242 20.5C37.8242 30.0513 30.0513 37.8242 20.5 37.8242Z",
    fill: "#6A6A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7713b58d0fb5d394d1ac3e3b6ac8622f.svg";
export { ForwardRef as ReactComponent };